/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* Emitted by campaignservice when an auto-redeploy verification chain exhausts its attempts cap without last_deploy_time advancing. Indicates the order line's intended state never reached its destinations.
*/
export class V1OrderLineRedeployVerificationFailed {
    'orderLineId'?: string;
    'orgId'?: string;
    'attemptCount'?: number;
    'lastDeployTimeSnapshot'?: Date;
    'lastAttemptTime'?: Date;
    'originalUserId'?: string;
    'originalRequestId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "attemptCount",
            "baseName": "attempt_count",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "lastDeployTimeSnapshot",
            "baseName": "last_deploy_time_snapshot",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastAttemptTime",
            "baseName": "last_attempt_time",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "originalUserId",
            "baseName": "original_user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "originalRequestId",
            "baseName": "original_request_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineRedeployVerificationFailed.attributeTypeMap;
    }

    public constructor() {
    }
}

